import {
  getHaBarDetailedByMonthAndGeo,
  getHaLineDetailedByMonthAndGeo
} from '../widgetsFunctionsHa'

export default {
  title: 'Default Dashboard Clinicas Ángeles',
  description: 'Dashboard de perfil  Clinicas Ángeles',
  widgets: (filters: FiltersUI) => {
    return [
      {
        title: 'Clínicas Ángeles',
        type: 'label',
        //position: [0, 0],
        size: [4, 1]
      },
      /**
     * NPS
     */
      getHaLineDetailedByMonthAndGeo({
        key: `nps-line-clinicas`,
        indicator: 'servicios_externos_diagnostico_pregunta_14',
        title: 'NPS General por mes Clínicas Ángeles',
        size: [4, 4],
        formula: 'nps-10',
        extraConfigs: {
          backgroundColor: '#3a1b52',
          theme: 'dark',
        },
        extras: {
          geoLocationInclude: [13651],
          //geoLocationInclude: [13151, 13152, 13153],
        },
        criticals: []
      }),
      getHaBarDetailedByMonthAndGeo({
        key: `nps-bar-clinicas`,
        indicator: 'servicios_externos_diagnostico_pregunta_14',
        title: 'NPS General por región Clínicas Ángeles',
        size: [4, 3],
        formula: 'nps-10',
        extraConfigs: {
          backgroundColor: '#3a1b52',
          theme: 'dark',
          rotateXAxisLegend: false,
          showValues: true
        },
        extras: {
          geoLocationInclude: [13651],
          //geoLocationInclude: [13151, 13152, 13153],
          groupByLevel: 4
        },
        criticals: []
      }),
      /**
       * Satisfacción
       */
      getHaLineDetailedByMonthAndGeo({
        key: `csat-line-clinicas`,
        indicator: 'servicios_externos_diagnostico_pregunta_6',
        title: 'Satisfacción General por mes Clínicas Ángeles',
        size: [4, 4],
        formula: 'nps-5',
        extraConfigs: {
          backgroundColor: '#3a1b52',
          theme: 'dark',
        },
        extras: {
          geoLocationInclude: [13651],
          //geoLocationInclude: [13151, 13152, 13153],
        },
        criticals: []
      }),
      getHaBarDetailedByMonthAndGeo({
        key: `csat-bar-clinicas`,
        indicator: 'servicios_externos_diagnostico_pregunta_6',
        title: 'Satisfacción General por región Clínicas Ángeles',
        size: [4, 3],
        formula: 'nps-5',
        extraConfigs: {
          backgroundColor: '#3a1b52',
          theme: 'dark',
          rotateXAxisLegend: false,
          showValues: true
        },
        extras: {
          geoLocationInclude: [13651],
          //geoLocationInclude: [13151, 13152, 13153],
          groupByLevel: 4
        },
        criticals: []
      })
    ]
  },
} as DasboardConfig
